<template>
    <section class="card sticky" v-if="trackerIdx !== null">
        <div class="columns">
            <b-field :label="'Translation (' + targetName + ')'" label-position="on-border">
                <b-input
                    class="tr-text"
                    ref="translation"
                    v-model="translated"
                    size="is-default"
                    @keypress.enter="$emit('move-tr', {direction:  1, untranslated: true})"
                    ></b-input>
            </b-field>
            <b-button class="button" icon-left="arrow-circle-left" size="is-default"
                :disabled="!original"
                @click="copyOriginal"
            ></b-button>
            <b-field label="Original" label-position="on-border">
                <b-input class="tr-text" disabled v-model="original" size="is-default"></b-input>
            </b-field>
            <a class="delete close-align-right" @click="$emit ('close')"></a>
        </div>
        <div class="columns">
            <b-button size="is-default"
                @click="$emit('move-tr', {direction: -1, untranslated: true})"
            >Prev</b-button>&nbsp;
            <b-button size="is-default"
                @click="$emit('move-tr', {direction:  1, untranslated: true})"
            >Next</b-button>&nbsp;
            <b-button type="is-success" :disabled="!changeCount" @click="saveChanges()">Save for Target Language: {{ targetName }} ({{ changeCount }})</b-button>
            &nbsp; {{ translatedTrUnits }} of  {{ totalTrUnits }} translated
        </div>
    </section>
</template>

<script>
import { mapGetters, mapState }       from 'vuex'
import debounce             from "@/debounce"

export default {
    name: "TrEdit",
    props: {
        tid: [String, Number],
        trackerIdx: Number,
        translatedTrUnits: Number,
        totalTrUnits: Number,
        vartext : {default: false},
    },
    computed: {
        ...mapState ("translation", {
            tids:        state => state.tid,
            targetLang:  state => state.targetLang,
            sourceLang:  state => state.sourceLang,
            languages:   state => state.languages,
            changeCount: state => state.changeCount,
        }),
        original () {
            return this.languages [this.sourceLang] [1] [this.tid]
        },
        targetName () {
            return this.languages [this.targetLang] [0]
        },
        translated : {
            get () {
                return this.languages [this.targetLang] [1] [this.tid] || ""
            },
            set (value) {
                this.setTranslation (this.$store, this.tid, value)
            }
        }
    },
    methods: {
        saveChanges() {
            this.$store.dispatch ("translation/saveChanges", {vartext: this.vartext, self: this})
        },
        copyOriginal () {
            this.translated = this.original
        },
        setTranslation : debounce (function (store, tid, value) {
            store.commit ("translation/changeTranslation", {tid, value})
        }, 250)
    },
    watch: {
        trackerIdx () {
           this.$nextTick (() => {
               if (this.$refs.translation)
                   this.$refs.translation.focus ()
           })
        }
    },
}
</script>

<style>
    .sticky {
        position: sticky;
        bottom:    5px;
        border:    2px solid rgb(184, 41, 41);
        border-radius: 5px;
    }
    section {
        padding: 2em 1em 1em 1em;
    }
    .tr-text {
        width:      25em !important;
    }
    .close-align-right {
        margin-left: auto
    }
</style>